import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'TOP', href: '/', external: false },
  { label: 'マウスピース矯正', href: '/mouthpiece', external: false },
  { label: 'SmarteeGS', href: 'https://smartee.saiwaidental.net', external: true },
  { label: 'ホワイトニング', href: '/whitening', external: false },
  { label: 'ICON白斑治療', href: '/icon', external: false },
  { label: '治療について', href: '/philosophy', external: false },
  { label: 'お知らせ', href: '/news/', external: false },
  { label: 'コラム', href: '/column/', external: false },
];

export default function CommonHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* ロゴ */}
          <Link to="/" className="flex-shrink-0">
            <img
              alt="さいわいデンタルクリニック"
              className="h-12 w-auto"
              src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1322x482_v-fms_webp_7d01fee7-6e4e-4d9f-82e3-16315023dc88_small.webp"
            />
          </Link>

          {/* デスクトップナビ */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-gray-900"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-gray-900"
                >
                  {link.label}
                </Link>
              )
            )}
          </nav>

          {/* 右側：電話 + 予約 + ハンバーガー */}
          <div className="flex items-center gap-4">
            {/* 電話エリア（デスクトップ） */}
            <div className="hidden md:flex items-center gap-2">
              <div className="flex items-center justify-center w-6 h-6">
                <i
                  className="fa-solid fa-phone text-xl"
                  style={{ color: '#3E5F8F' }}
                />
              </div>
              <div className="text-left">
                <a
                  href="tel:05018094594"
                  className="block font-bold text-sm hover:underline cursor-pointer whitespace-nowrap text-gray-900"
                >
                  050-1809-4594
                </a>
                <p className="text-xs whitespace-nowrap text-gray-600">
                  10:00~19:00(最終受付18:00)
                </p>
                <p
                  className="text-xs font-medium whitespace-nowrap"
                  style={{ color: '#3E5F8F' }}
                >
                  ご相談予約
                </p>
              </div>
            </div>

            {/* WEB予約ボタン（デスクトップ） */}
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:block text-white px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ backgroundColor: '#3E5F8F' }}
            >
              ご相談予約
            </a>

            {/* ハンバーガー（モバイル） */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer text-gray-800"
              aria-label="メニュー"
            >
              <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'} text-xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* モバイルメニュー */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMenuOpen(false)}
                  className="block py-2 text-gray-800 hover:text-teal-600 text-sm font-medium transition-colors"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block py-2 text-gray-800 hover:text-teal-600 text-sm font-medium transition-colors"
                >
                  {link.label}
                </Link>
              )
            )}
            <div className="pt-3 border-t border-gray-100">
              <a
                href="tel:05018094594"
                className="flex items-center gap-2 py-2 text-gray-800"
              >
                <i className="fa-solid fa-phone" style={{ color: '#3E5F8F' }} />
                <span className="font-bold text-sm">050-1809-4594</span>
              </a>
              <p className="text-xs text-gray-600 pl-6">10:00~19:00(最終受付18:00)</p>
              <a
                href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 block text-center text-white px-4 py-2 rounded-lg font-medium text-sm"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                WEB予約
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}